import { Grid } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import CustomTable from '../../components/common/CustomTable/CustomTable';
import { useImportStore } from '../../hooks/useImportStore';
import { ApiStatus } from '../../types/api/status';
import { RoutesMap } from '../../types';
import { ModalUploadDocument } from '../../components/common/ModalUploadDocument/ModalUploadDocument';
import { CustomSnackbar } from '../../components/common/CustomSnackbar/CustomSnackbar';

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    // { type: 'text', field: 'id', label: 'N°', align: 'center', format: (row, index) => index + 1 },
    { type: 'text', field: 'description', label: 'Descripción', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Plantillas de importación', pathname: RoutesMap.IMPORT_LIST }
]

export const ImportList: FC = () => {

    const { status, imports, getImports, updateImport, downloadTemplate } = useImportStore()

    const [rowSelected, setRowSelected] = useState<any>(null)
    const [showModalUpload, setShowModalUpload] = useState<boolean>(false)
    const [searchTimeout, setSearchTimeout] = useState<any>(null)

    useEffect(() => {
        getImportsApi()
    }, [])

    const getImportsApi = async (data?: any) => {
        await getImports(data)
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getImportsApi({ search: term }) }, 1000)
        )
    }

    const onUpload = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalUpload(true)
    }

    const onDetails = async (rowSelected) => {
        const url: string | false = await downloadTemplate(rowSelected.id)
        if (url === false) return

        const win: any = window.open(`${process.env.REACT_APP_ROOT_URL}` + url)
        win.focus()
    }

    return (
        <Grid item xs={12}>
            <CustomTable
                breadcrumbs={breadcrumbs}
                title={'Plantillas de importaciones'}
                columns={columns}
                loading={status === ApiStatus.FETCHING}
                rows={imports || []}
                onRowClick={() => { }}
                hasOptions
                onDetails={onDetails}
                onUpload={onUpload}
                onSearch={onSearch}
                dense
            />
            {
                showModalUpload &&
                <ModalUploadDocument
                    open={showModalUpload}
                    rowSelected={rowSelected}
                    closeModal={() => setShowModalUpload(false)}
                    onList={() => getImportsApi()}
                    status={status}
                    uploadDocument={updateImport}
                />
            }
        </Grid>
    )
}